<template>
  <router-view></router-view>
</template>
<script setup>
import { jwtDecode } from "jwt-decode";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

import apiUser from "@/api/api/apiUser.js";
import { getLatestUtmSourceFromCookie } from "@/api/net/config.js";
import message from "@/components/functionCallComponent/message/message.js";
import useUserDataStore from "@/store/userDataStore";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
// import { AwsRum } from "aws-rum-web"

const Router = useRouter();

const userDataStore = useUserDataStore();

const updateAuthData = (_data) => {
  userDataStore.upDataAuthData(_data.auth);
  userDataStore.updateLoginStatus(true);
};

const getQueryParameter = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

const getAccessToken = (url) => {
  const params = new URLSearchParams(url.split("#")[1]);
  return params.get("access_token");
};

const isEmailPasswordCallback = () => {
  const emailPasswordPaths = [
    "/email-password",
    "/change-password",
    "/reset-password",
    "/reset-password-used",
    "/sign-in/set-password",
    "/zh-Hans/sign-in/set-password",
    "/sign-up-success",
    "/sign-up-fail",
  ];
  return (
    !emailPasswordPaths.some((path) =>
      window.location.pathname.endsWith(path)
    ) &&
    (getQueryParameter("email_password") === "1" ||
      getQueryParameter("email_verify") === "1" ||
      getQueryParameter("password_reset") === "1" ||
      getQueryParameter("t") ||
      (getQueryParameter("code") && !getQueryParameter("id_token")))
  );
};

const redirectEmailPasswordCallback = async () => {
  if (!isEmailPasswordCallback()) return false;

  const url = new URL(window.location.href);
  const query = {};
  ["code", "t", "lang", "password_reset", "email", "redirect_url"].forEach(
    (key) => {
      const value = url.searchParams.get(key);
      if (value) query[key] = value;
    }
  );
  const isResetPassword =
    !window.location.pathname.includes("set-password") &&
    (query.password_reset === "1" ||
      Boolean(query.t) ||
      window.location.pathname.includes("reset-password"));

  await Router.replace({
    name: isResetPassword ? "resetPassword" : "setPassword",
    query,
  });
  return true;
};

const loginByIdToken = async (token) => {
  const decoded = jwtDecode(token);
  const { data, code, msg } = await apiUser.userLogin({
    mode: "apple",
    extra_token: getQueryParameter("code") ?? "",
    token: decoded?.sub ?? "",
    source: getLatestUtmSourceFromCookie() ?? "",
    signup_source: userDataStore.getSignupSource(),
    activity_source: userDataStore.getActivitySource(),
  });
  if (code === 200) {
    console.log("第三方登录成功");
    updateAuthData(data);
    firebaseUtils.logCustomEvent("api_sign_in", { method: "apple" }, "success");
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete("id_token");
    url.search = params.toString();
    window.history.replaceState({}, "", url.toString());
  } else if (code == 6401) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "Deleted accounts cannot be registered within 14 days.",
    });
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    });
  }
};

const loginByAccessToken = async (accessToken) => {
  const { data, code, msg } = await apiUser.userLogin({
    mode: "discord",
    token: accessToken,
    source: getLatestUtmSourceFromCookie() ?? "",
    signup_source: userDataStore.getSignupSource(),
    activity_source: userDataStore.getActivitySource(),
  });
  if (code === 200) {
    console.log("第三方登录成功");
    updateAuthData(data);
    firebaseUtils.logCustomEvent(
      "api_sign_in",
      { method: "discord" },
      "success"
    );
    window.location.hash = "";
  } else if (code == 6401) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "Deleted accounts cannot be registered within 14 days.",
    });
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    });
  }
};

const threeLoginStateGet = async () => {
  if (await redirectEmailPasswordCallback()) {
    return;
  }

  const id_token = getQueryParameter("id_token") ?? "";
  if (id_token) {
    await loginByIdToken(id_token);
    return;
  }
  const accessToken = getAccessToken(window.location.href) ?? "";
  if (accessToken) {
    await loginByAccessToken(accessToken);
    return;
  }

  userDataStore.init();
};

onMounted(async () => {
  threeLoginStateGet();
});
</script>
<style lang="scss">
// .lottie-animation-contaniner {
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: #fff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   .lottie-animation-content {
//     height: 80px;
//     width: 80px;
//   }
// }
</style>
